import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import "./App.scss";
import Home from "./pages/Home";
import About from "./pages/About";
import Works from "./pages/Works";
import Archive from "./pages/Archive";
import View from "./pages/View";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/about" component={About} />
        <Route exact path="/works" component={Works} />
        <Route exact path="/archive" component={Archive} />
        <Route exact path="/view/:prefix" component={View} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
